/**
 * Feature flag constants
 *
 * @desc JS counterpart of Feature.php class
 */
export const AA_ACCOUNT_COUPON_REDEEM = 'aa_account_coupon_redeem';
export const AA_ADDITIONAL_LOGIN = 'AA_ADDITIONAL_LOGIN';
export const AA_ADDONS = 'aa_addons';
export const AA_ANNUAL_PLAN = 'aa_annual_plan';
export const AA_MULTI_SUB_PLAN_PICKER = 'aa_multi_sub_plan_picker';
export const AA_DYNAMIC_AGREEMENT_COPY = 'aa_dynamic_agreement_copy';
export const AA_EDU = 'aa_edu';
export const AA_GIFT = 'aa_gift';
export const AA_PACKAGE_SWITCH = 'aa_package_switch';
export const AA_PAYPAL = 'aa_paypal';
export const AA_PURCHASE = 'aa_purchase';
export const AA_PURCHASE_REVIEW_SCREEN = 'aa_purchase_review_screen';
export const ANON_CONTENTS = 'anon_contents';
export const AVATARS_V2 = 'avatars_v2_enabled';
export const SPOTLIGHT_CAROUSEL_ENABLED = 'spotlight_single_promo_enabled';
export const CAROUSEL_OF_HUBS_ENABLED = 'carousel_of_hubs_enabled';
export const CBSN = 'cbsn';
export const COLD_START_PREMIUM_LOCKS_ENABLED = 'cold_start_premium_locks_enabled';
export const ENHANCED_KIDS_PRIVACY_ENABLED = 'enhanced_kids_privacy_enabled';
export const ETL = 'etl';
export const FTC_COMPLIANCE_ENABLED = 'ftc_compliance_enabled';
export const FTC_COMPLIANCE_PICKAPLAN_ENABLED = 'ftc_compliance_pickaplan_enabled';
export const FTC_COMPLIANCE_UPSELL_ENABLED = 'ftc_compliance_upsell_enabled';
export const FTC_COMPLIANCE_SWITCHPLAN_ENABLED = 'ftc_compliance_switchplan_enabled';
export const FTC_COMPLIANCE_CHECKBOX_ENABLED = 'ftc_compliance_checkbox_enabled';
export const FTC_COMPLIANCE_COUPON_REDEEM_ENABLED = 'ftc_compliance_coupon_redeem_enabled';
export const HLS_VIDEO_PREVIEW_ENABLED = 'hls_video_preview_enabled';
export const LOCAL_LIVE_TV = 'local_live_tv';
export const MFE_ENABLED = 'mfe_enabled';
export const MFE_USERPROFILES_ENABLED = 'mfe_userprofiles_enabled';
export const MOVIES = 'movies';
export const MULTI_SUB_PLAN_PICKER_ENABLED = 'multi_sub_plan_picker_enabled';
export const MVPD = 'mvpd';
export const PASSWORD_RESET_FLOW = 'password_reset_flow';
// START AB Test PLOCTOPLUS-2033
export const PAYMENT_LOCK_ICON = 'payment_lock_icon';
// END AB Test PLOCTOPLUS-2033
export const PAYMENT_SUMMARY_CHANGE_LINK_ENABLED = 'payment_summary_change_link_enabled';
export const PIN_CONTROLS = 'pin_controls';
export const PRICE_WITH_ASTERISK = 'price_with_asterisk';
export const REDFAST_ENABLED = 'redfast_enabled';
export const REGIONAL_SKUS = 'regional_skus';
export const RENDEZVOUS = 'rendezvous';
export const RESELLER_DELTA_AUTO_LOGIN = 'reseller_delta_auto_login';
export const RESELLER_DELTA_DEPEVIEW = 'reseller_delta_deepview';
export const RESELLER_DELTA_JOURNEY = 'reseller_delta_journey';
export const RESELLER_DELTA_JOURNEY_SIGN_IN = 'reseller_delta_journey_sign_in';
export const RESELLER_DELTA_JOURNEY_SIGN_UP = 'reseller_delta_journey_sign_up';
export const SCREENTIME_LIMIT_ENABLED = 'screentime_limit_enabled';
export const SHARED_PAYMENT_COMPONENT = 'shared_payment_component';
export const SHOW_INNER_PAGES = 'show_inner_pages';
export const SHOW_PICKER = 'show_picker';
export const SHOWHIDE_PASSWORD = 'show_hide_password';
export const SHOWPICKER_WATCHLIST_ENABLED = 'showpicker_watchlist_enabled';
export const SITE_SEARCH = 'site_search';
export const SPORTS_HQ = 'sports_hq';
export const SWITCH_PROFILE_PIN_ENABLED = 'switch_profile_pin_enabled';
export const TUNE_IN_INFO = 'tune_in_info';
export const TVE_GHOST_ACCOUNT = 'tve_ghost_account';
export const USER_PROFILES = 'user_profiles';
export const RECAPTCHA = 'recaptcha';
export const UPGRADE_ANNUAL_TOGGLE = 'upgrade_annual_toggle';
export const UPSELL_PLANS_ANNUAL = 'upsell_plans_annual';
// START TEST PLOCTOPLUS-2890: A/B TEST: Pre-Select Paramount+ with SHO Plan
export const PLAN_WITH_SHO_PRESELECTED = 'plan_with_sho_preselected';
export const PLAN_WITH_SHO_PRE_SELECTED_ONE_CTA = 'plan_with_sho_preselected_one_cta';
// END TEST PLOCTOPLUS-2890: A/B TEST: Pre-Select Paramount+ with SHO Plan
export const WEB_EPISODE_DESCRIPTION_ENABLED = 'web_episode_descriptions_enabled';
export const PAYMENT_EXSUB_BILLING_SUMMARY = 'payment_exsub_billing_summary';
